module.exports = __webpack_public_path__ + "img/img_cs_phone_banner.b351b78a.png";